import { makeUniqueId } from '@/utils';
export default {
  inheritAttrs: false,
  props: {
    name: {
      type: String,
      required: true,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    modelValue: null,
    value: {
      type: [String, Boolean]
    },
    checked: {
      type: [String, Boolean]
    },
    disabled: {
      type: [String, Boolean]
    },
    helpText: {
      type: String,
      default: ''
    },
    options: {
      type: Array,
      default: new Array()
    },
    errorText: {
      type: String,
      default: ''
    }
  },
  computed: {
    randomId() {
      return makeUniqueId(this.name, 6);
    }
  },
  methods: {
    toggleCheckbox(event) {
      this.$props.modelValue = !this.$props.modelValue;
      this.$props.checked = !this.$props.checked;
      this.$refs.dcForm_checkbox.handleChange();
    }
  }
};